import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IService } from '../Models/IService';
import { IServiceAssignment } from '../Models/IServiceAssignment';
import { IServiceLog } from '../Models/IServiceLog';
import { IServiceRequestParameters } from '../Models/IServiceRequestParameters';
import { ILookupBase } from '../Models/ILookupBase';

@Injectable()
export class ServicesService extends BaseService {
  _baseUrl: string = "";

  constructor(
    protected _http: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  )
  {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getService(id: number): Observable<IService> {
    return this._http.get<IService>(this._baseUrl + "api/Service/GetService/" + id)
      .map((response: IService) => response as IService)
      .catch(this.errorHandler);
  }

  getServices(serviceRequestParameters: IServiceRequestParameters): Observable<IService[]> {
    return this._http.post<IService[]>(this._baseUrl + "api/Service/GetServices", serviceRequestParameters)
      .map((response: IService[]) => response as IService[])
      .catch(this.errorHandler);
  }

  getCurrentServices(localStudentId: string): Observable<IService[]> {
    return this._http.get<IService[]>(this._baseUrl + "api/Service/GetCurrentServices/" + localStudentId)
      .map((response: IService[]) => response as IService[])
      .catch(this.errorHandler);
  }

  getMatchingServiceProviders(siteId: string, specialEducationServiceCode: number): Observable<ILookupBase[]> {
    let parameters = siteId + '^' + specialEducationServiceCode.toString();

    return this._http.get<ILookupBase[]>(this._baseUrl + "api/Service/GetMatchingServiceProviders/"+ parameters)
      .map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.errorHandler);
  }

  getServiceAssignment(id: number): Observable<IServiceAssignment> {
    return this._http.get<IServiceAssignment>(this._baseUrl + "api/Service/GetServiceAssignment/" + id)
      .map((response: IServiceAssignment) => response as IServiceAssignment)
      .catch(this.errorHandler);
  }

  getServiceAssignments(serviceRequestParameters: IServiceRequestParameters): Observable<IServiceAssignment[]> {
    return this._http.post<IServiceAssignment[]>(this._baseUrl + "api/Service/GetServiceAssignments", serviceRequestParameters)
      .map((response: IServiceAssignment[]) => response as IServiceAssignment[])
      .catch(this.errorHandler);
  }

  getServiceAssignmentsForStudent(localstudentId: string): Observable<IServiceAssignment[]> {
    return this._http.get<IServiceAssignment[]>(this._baseUrl + "api/Service/GetServiceAssignmentsForStudent/" + localstudentId)
      .map((response: IServiceAssignment[]) => response as IServiceAssignment[])
      .catch(this.errorHandler);
  }

  getServiceLog(id: number): Observable<IServiceLog> {
    return this._http.get<IServiceLog>(this._baseUrl + "api/Service/GetServiceLog/" + id)
      .map((response: IServiceLog) => response as IServiceLog)
      .catch(this.errorHandler);
  }

  getServiceLogs(serviceAssignmentId: number): Observable<IServiceLog[]> {
    return this._http.get<IServiceLog[]>(this._baseUrl + "api/Service/GetServiceLogs/" + serviceAssignmentId)
      .map((response: IServiceLog[]) => response as IServiceLog[])
      .catch(this.errorHandler);
  }

  insertUpdateService(serviceDetails: IService): Observable<IService> {
    return this._http.post<IService>(this._baseUrl + 'api/Service/InsertUpdateService', serviceDetails)
      .map((response: IService) => response as IService)
      .catch(this.errorHandler);
  }

  insertUpdateServiceAssignment(serviceAssignmentDetails: IServiceAssignment): Observable<IServiceAssignment> {
    return this._http.post<IServiceAssignment>(this._baseUrl + 'api/Service/InsertUpdateServiceAssignment', serviceAssignmentDetails)
      .map((response: IServiceAssignment) => response as IServiceAssignment)
      .catch(this.errorHandler);
  }

  deleteServiceAssignment(serviceAssignmentId: number): Observable<boolean> {
    return this._http.get<boolean>(this._baseUrl + "api/Service/DeleteServiceAssignment/" + serviceAssignmentId)
      .map((response: boolean) => response as boolean)
      .catch(this.errorHandler);
  }

  insertUpdateServiceLog(serviceLogDetails: IServiceLog): Observable<IServiceLog> {
    return this._http.post<IServiceLog>(this._baseUrl + 'api/Service/InsertUpdateServiceLog', serviceLogDetails)
      .map((response: IServiceLog) => response as IServiceLog)
      .catch(this.errorHandler);
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

}
